var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"dashboard-bar-chart",attrs:{"bordered":false}},[_c('chart-bar',{attrs:{"height":250,"data":_vm.barChartData}}),_c('div',{staticClass:"card-title"},[_c('h6',[_vm._v("Learners by Class")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }